export default __webpack_public_path__ + "static/media/source--240.5a95271d.jpg";